module.exports = __webpack_public_path__ + "img/video-thumb-2-fr.6f580583.png";